// extracted by mini-css-extract-plugin
export default {"toolTip":"cJ_lh","content":"cJ_d"};